[
  {
    "id": 1,
    "name": "INTERNATIONAL",
    "short_name": "int",
    "code": 0,
    "currency": "USD"
  },
  {
    "id": 2,
    "name": "AFGHANISTAN",
    "short_name": "AF",
    "code": "93",
    "currency": "AFN"
  },
  {
    "id": 3,
    "name": "ALBANIA",
    "short_name": "AL",
    "code": "355",
    "currency": "ALL"
  },
  {
    "id": 4,
    "name": "ALGERIA",
    "short_name": "DZ",
    "code": "213",
    "currency": "DZD"
  },
  {
    "id": 5,
    "name": "AMERICAN SAMOA",
    "short_name": "AS",
    "code": "1-684",
    "currency": "USD"
  },
  {
    "id": 6,
    "name": "ANDORRA",
    "short_name": "AD",
    "code": "376",
    "currency": "EUR"
  },
  {
    "id": 7,
    "name": "ANGOLA",
    "short_name": "AO",
    "code": "244",
    "currency": "AOA"
  },
  {
    "id": 8,
    "name": "ANGUILLA",
    "short_name": "AI",
    "code": "1-264",
    "currency": "USD"
  },
  {
    "id": 9,
    "name": "ANTARCTICA",
    "short_name": "AQ",
    "code": "672",
    "currency": "USD"
  },
  {
    "id": 10,
    "name": "ANTIGUA AND BARBUDA",
    "short_name": "AG",
    "code": "1-268",
    "currency": "USD"
  },
  {
    "id": 11,
    "name": "ARGENTINA",
    "short_name": "AR",
    "code": "54",
    "currency": "ARS"
  },
  {
    "id": 12,
    "name": "ARMENIA",
    "short_name": "AM",
    "code": "374",
    "currency": "AMD"
  },
  {
    "id": 13,
    "name": "ARUBA",
    "short_name": "AW",
    "code": "297",
    "currency": "USD"
  },
  {
    "id": 14,
    "name": "AUSTRALIA",
    "short_name": "AU",
    "code": "61",
    "currency": "AUD"
  },
  {
    "id": 15,
    "name": "AUSTRIA",
    "short_name": "AT",
    "code": "43",
    "currency": "EUR"
  },
  {
    "id": 16,
    "name": "AZERBAIJAN",
    "short_name": "AZ",
    "code": "994",
    "currency": "AZN"
  },
  {
    "id": 17,
    "name": "BAHAMAS",
    "short_name": "BS",
    "code": "1-242",
    "currency": "USD"
  },
  {
    "id": 18,
    "name": "BAHRAIN",
    "short_name": "BH",
    "code": "973",
    "currency": "BHD"
  },
  {
    "id": 19,
    "name": "BANGLADESH",
    "short_name": "BD",
    "code": "880",
    "currency": "BDT"
  },
  {
    "id": 20,
    "name": "BARBADOS",
    "short_name": "BB",
    "code": "1-246",
    "currency": "USD"
  },
  {
    "id": 21,
    "name": "BELARUS",
    "short_name": "BY",
    "code": "375",
    "currency": "EUR"
  },
  {
    "id": 22,
    "name": "BELGIUM",
    "short_name": "BE",
    "code": "32",
    "currency": "EUR"
  },
  {
    "id": 23,
    "name": "BELIZE",
    "short_name": "BZ",
    "code": "501",
    "currency": "USD"
  },
  {
    "id": 24,
    "name": "BENIN",
    "short_name": "BJ",
    "code": "229",
    "currency": "XOF"
  },
  {
    "id": 25,
    "name": "BERMUDA",
    "short_name": "BM",
    "code": "1-441",
    "currency": "USD"
  },
  {
    "id": 26,
    "name": "BHUTAN",
    "short_name": "BT",
    "code": "975",
    "currency": "BTN"
  },
  {
    "id": 27,
    "name": "BOLIVIA",
    "short_name": "BO",
    "code": "591",
    "currency": "BOB"
  },
  {
    "id": 28,
    "name": "BOSNIA AND HERZEGOVINA",
    "short_name": "BA",
    "code": "387",
    "currency": "BAM"
  },
  {
    "id": 29,
    "name": "BOTSWANA",
    "short_name": "BW",
    "code": "267",
    "currency": "BWP"
  },
  {
    "id": 30,
    "name": "BRASIL",
    "language_id": "4",
    "language": "pt",
    "short_name": "BR",
    "code": "55",
    "currency": "BRL"
  },
  {
    "id": 31,
    "name": "BRITISH INDIAN OCEAN TERRITORY",
    "short_name": "IO",
    "code": "246",
    "currency": "USD"
  },
  {
    "id": 32,
    "name": "BRITISH VIRGIN ISLANDS",
    "short_name": "VG",
    "code": "1-284",
    "currency": "USD"
  },
  {
    "id": 33,
    "name": "BRUNEI",
    "short_name": "BN",
    "code": "673",
    "currency": "BND"
  },
  {
    "id": 34,
    "name": "BULGARIA",
    "short_name": "BG",
    "code": "359",
    "currency": "BGN"
  },
  {
    "id": 35,
    "name": "BURKINA FASO",
    "short_name": "BF",
    "code": "226",
    "currency": "XOF"
  },
  {
    "id": 36,
    "name": "BURUNDI",
    "short_name": "BI",
    "code": "257",
    "currency": "BIF"
  },
  {
    "id": 37,
    "name": "CAMBODIA",
    "short_name": "KH",
    "code": "855",
    "currency": "KHR"
  },
  {
    "id": 38,
    "name": "CAMEROON",
    "short_name": "CM",
    "code": "237",
    "currency": "XAF"
  },
  {
    "id": 39,
    "name": "CANADA",
    "short_name": "CA",
    "code": "1",
    "currency": "CAD"
  },
  {
    "id": 40,
    "name": "CAPE VERDE",
    "short_name": "CV",
    "code": "238",
    "currency": "CVE"
  },
  {
    "id": 41,
    "name": "CAYMAN ISLANDS",
    "short_name": "KY",
    "code": "1-345",
    "currency": "USD"
  },
  {
    "id": 42,
    "name": "CENTRAL AFRICAN REPUBLIC",
    "short_name": "CF",
    "code": "236",
    "currency": "XAF"
  },
  {
    "id": 43,
    "name": "CHAD",
    "short_name": "TD",
    "code": "235",
    "currency": "XAF"
  },
  {
    "id": 44,
    "name": "CHILE",
    "short_name": "CL",
    "code": "56",
    "currency": "CLP"
  },
  {
    "id": 45,
    "name": "CHINA",
    "short_name": "CN",
    "code": "86",
    "currency": "CNY"
  },
  {
    "id": 46,
    "name": "CHRISTMAS ISLAND",
    "short_name": "CX",
    "code": "61",
    "currency": "USD"
  },
  {
    "id": 47,
    "name": "COCOS ISLANDS",
    "short_name": "CC",
    "code": "61",
    "currency": "USD"
  },
  {
    "id": 48,
    "name": "COLOMBIA",
    "short_name": "CO",
    "code": "57",
    "currency": "COP"
  },
  {
    "id": 49,
    "name": "COMOROS",
    "short_name": "KM",
    "code": "269",
    "currency": "KMF"
  },
  {
    "id": 50,
    "name": "COOK ISLANDS",
    "short_name": "CK",
    "code": "682",
    "currency": "USD"
  },
  {
    "id": 51,
    "name": "COSTA RICA",
    "short_name": "CR",
    "code": "506",
    "currency": "CRC"
  },
  {
    "id": 52,
    "name": "CROATIA",
    "short_name": "HR",
    "code": "385",
    "currency": "HRK"
  },
  {
    "id": 53,
    "name": "CUBA",
    "short_name": "CU",
    "code": "53",
    "currency": "USD"
  },
  {
    "id": 54,
    "name": "CURACAO",
    "short_name": "CW",
    "code": "599",
    "currency": "USD"
  },
  {
    "id": 55,
    "name": "CYPRUS",
    "short_name": "CY",
    "code": "357",
    "currency": "USD"
  },
  {
    "id": 56,
    "name": "CZECH REPUBLIC",
    "short_name": "CZ",
    "code": "420",
    "currency": "EUR"
  },
  {
    "id": 57,
    "name": "DEMOCRATIC REPUBLIC OF THE CONGO",
    "short_name": "CD",
    "code": "243",
    "currency": "CDF"
  },
  {
    "id": 58,
    "name": "DENMARK",
    "short_name": "DK",
    "code": "45",
    "currency": "DKK"
  },
  {
    "id": 59,
    "name": "DJIBOUTI",
    "short_name": "DJ",
    "code": "253",
    "currency": "DJF"
  },
  {
    "id": 60,
    "name": "DOMINICA",
    "short_name": "DM",
    "code": "1-767",
    "currency": "XCD"
  },
  {
    "id": 61,
    "name": "REPUBLICA DOMINICANA",
    "short_name": "DO",
    "code": "1-809",
    "currency": "DOP"
  },
  {
    "id": 61,
    "name": "REPUBLICA DOMINICANA",
    "short_name": "DO",
    "code": "1-829",
    "currency": "DOP"
  },
  {
    "id": 61,
    "name": "REPUBLICA DOMINICANA",
    "short_name": "DO",
    "code": "1-849",
    "currency": "DOP"
  },
  {
    "id": 62,
    "name": "EAST TIMOR",
    "short_name": "TL",
    "code": "670",
    "currency": "USD"
  },
  {
    "id": 63,
    "name": "ECUADOR",
    "short_name": "EC",
    "code": "593",
    "currency": "USD"
  },
  {
    "id": 64,
    "name": "EGYPT",
    "short_name": "EG",
    "code": "20",
    "currency": "EGP"
  },
  {
    "id": 65,
    "name": "EL SALVADOR",
    "short_name": "SV",
    "code": "503",
    "currency": "USD"
  },
  {
    "id": 66,
    "name": "EQUATORIAL GUINEA",
    "short_name": "GQ",
    "code": "240",
    "currency": "XAF"
  },
  {
    "id": 67,
    "name": "ERITREA",
    "short_name": "ER",
    "code": "291",
    "currency": "ERN"
  },
  {
    "id": 68,
    "name": "ESTONIA",
    "short_name": "EE",
    "code": "372",
    "currency": "EUR"
  },
  {
    "id": 69,
    "name": "ETHIOPIA",
    "short_name": "ET",
    "code": "251",
    "currency": "ETB"
  },
  {
    "id": 70,
    "name": "FALKLAND ISLANDS",
    "short_name": "FK",
    "code": "500",
    "currency": "USD"
  },
  {
    "id": 71,
    "name": "FAROE ISLANDS",
    "short_name": "FO",
    "code": "298",
    "currency": "USD"
  },
  {
    "id": 72,
    "name": "FIJI",
    "short_name": "FJ",
    "code": "679",
    "currency": "USD"
  },
  {
    "id": 73,
    "name": "FINLAND",
    "short_name": "FI",
    "code": "358",
    "currency": "EUR"
  },
  {
    "id": 74,
    "name": "FRANCIA",
    "short_name": "FR",
    "code": "33",
    "currency": "EUR"
  },
  {
    "id": 75,
    "name": "FRENCH POLYNESIA",
    "short_name": "PF",
    "code": "689",
    "currency": "USD"
  },
  {
    "id": 76,
    "name": "GABON",
    "short_name": "GA",
    "code": "241",
    "currency": "XAF"
  },
  {
    "id": 77,
    "name": "GAMBIA",
    "short_name": "GM",
    "code": "220",
    "currency": "GMD"
  },
  {
    "id": 78,
    "name": "GEORGIA",
    "short_name": "GE",
    "code": "995",
    "currency": "GEL"
  },
  {
    "id": 79,
    "name": "ALEMANIA",
    "short_name": "DE",
    "code": "49",
    "currency": "EUR"
  },
  {
    "id": 80,
    "name": "GHANA",
    "short_name": "GH",
    "code": "233",
    "currency": "GHS"
  },
  {
    "id": 81,
    "name": "GIBRALTAR",
    "short_name": "GI",
    "code": "350",
    "currency": "USD"
  },
  {
    "id": 82,
    "name": "GREECE",
    "short_name": "GR",
    "code": "30",
    "currency": "EUR"
  },
  {
    "id": 83,
    "name": "GREENLAND",
    "short_name": "GL",
    "code": "299",
    "currency": "USD"
  },
  {
    "id": 84,
    "name": "GRENADA",
    "short_name": "GD",
    "code": "1-473",
    "currency": "XCD"
  },
  {
    "id": 85,
    "name": "GUAM",
    "short_name": "GU",
    "code": "1-671",
    "currency": "USD"
  },
  {
    "id": 86,
    "name": "GUATEMALA",
    "short_name": "GT",
    "code": "502",
    "currency": "GTQ"
  },
  {
    "id": 87,
    "name": "GUERNSEY",
    "short_name": "GG",
    "code": "44-1481",
    "currency": "USD"
  },
  {
    "id": 88,
    "name": "GUINEA",
    "short_name": "GN",
    "code": "224",
    "currency": "GNF"
  },
  {
    "id": 89,
    "name": "GUINEA-BISSAU",
    "short_name": "GW",
    "code": "245",
    "currency": "XOF"
  },
  {
    "id": 90,
    "name": "GUYANA",
    "short_name": "GY",
    "code": "592",
    "currency": "GYD"
  },
  {
    "id": 91,
    "name": "HAITI",
    "short_name": "HT",
    "code": "509",
    "currency": "HTG"
  },
  {
    "id": 92,
    "name": "HONDURAS",
    "short_name": "HN",
    "code": "504",
    "currency": "HNL"
  },
  {
    "id": 93,
    "name": "HONG KONG",
    "short_name": "HK",
    "code": "852",
    "currency": "USD"
  },
  {
    "id": 94,
    "name": "HUNGARY",
    "short_name": "HU",
    "code": "36",
    "currency": "HUF"
  },
  {
    "id": 95,
    "name": "ISLANDIA",
    "short_name": "IS",
    "code": "354",
    "currency": "ISK"
  },
  {
    "id": 96,
    "name": "INDIA",
    "short_name": "IN",
    "code": "91",
    "currency": "INR"
  },
  {
    "id": 97,
    "name": "INDONESIA",
    "short_name": "ID",
    "code": "62",
    "currency": "USD"
  },
  {
    "id": 98,
    "name": "IRAN",
    "short_name": "IR",
    "code": "98",
    "currency": "USD"
  },
  {
    "id": 99,
    "name": "IRAQ",
    "short_name": "IQ",
    "code": "964",
    "currency": "USD"
  },
  {
    "id": 100,
    "name": "IRELAND",
    "short_name": "IE",
    "code": "353",
    "currency": "EUR"
  },
  {
    "id": 101,
    "name": "ISLE OF MAN",
    "short_name": "IM",
    "code": "44-1624",
    "currency": "USD"
  },
  {
    "id": 102,
    "name": "ISRAEL",
    "short_name": "IL",
    "code": "972",
    "currency": "USD"
  },
  {
    "id": 103,
    "name": "ITALIA",
    "short_name": "IT",
    "code": "39",
    "currency": "EUR"
  },
  {
    "id": 104,
    "name": "IVORY COAST",
    "short_name": "CI",
    "code": "225",
    "currency": "XOF"
  },
  {
    "id": 105,
    "name": "JAMAICA",
    "short_name": "JM",
    "code": "1-876",
    "currency": "JMD"
  },
  {
    "id": 106,
    "name": "JAPON",
    "short_name": "JP",
    "code": "81",
    "currency": "USD"
  },
  {
    "id": 107,
    "name": "JERSEY",
    "short_name": "JE",
    "code": "44-1534",
    "currency": "USD"
  },
  {
    "id": 108,
    "name": "JORDAN",
    "short_name": "JO",
    "code": "962",
    "currency": "USD"
  },
  {
    "id": 109,
    "name": "KAZAKHSTAN",
    "short_name": "KZ",
    "code": "7",
    "currency": "USD"
  },
  {
    "id": 110,
    "name": "KENYA",
    "short_name": "KE",
    "code": "254",
    "currency": "KES"
  },
  {
    "id": 111,
    "name": "KIRIBATI",
    "short_name": "KI",
    "code": "686",
    "currency": "USD"
  },
  {
    "id": 112,
    "name": "KOSOVO",
    "short_name": "XK",
    "code": "383",
    "currency": "USD"
  },
  {
    "id": 113,
    "name": "KUWAIT",
    "short_name": "KW",
    "code": "965",
    "currency": "USD"
  },
  {
    "id": 114,
    "name": "KYRGYZSTAN",
    "short_name": "KG",
    "code": "996",
    "currency": "USD"
  },
  {
    "id": 115,
    "name": "LAOS",
    "short_name": "LA",
    "code": "856",
    "currency": "USD"
  },
  {
    "id": 116,
    "name": "LATVIA",
    "short_name": "LV",
    "code": "371",
    "currency": "EUR"
  },
  {
    "id": 117,
    "name": "LEBANON",
    "short_name": "LB",
    "code": "961",
    "currency": "USD"
  },
  {
    "id": 118,
    "name": "LESOTHO",
    "short_name": "LS",
    "code": "266",
    "currency": "ZAR"
  },
  {
    "id": 119,
    "name": "LIBERIA",
    "short_name": "LR",
    "code": "231",
    "currency": "LRD"
  },
  {
    "id": 120,
    "name": "LIBYA",
    "short_name": "LY",
    "code": "218",
    "currency": "LYD"
  },
  {
    "id": 121,
    "name": "LIECHTENSTEIN",
    "short_name": "LI",
    "code": "423",
    "currency": "CHF"
  },
  {
    "id": 122,
    "name": "LITHUANIA",
    "short_name": "LT",
    "code": "370",
    "currency": "EUR"
  },
  {
    "id": 123,
    "name": "LUXEMBOURG",
    "short_name": "LU",
    "code": "352",
    "currency": "EUR"
  },
  {
    "id": 124,
    "name": "MACAU",
    "short_name": "MO",
    "code": "853",
    "currency": "USD"
  },
  {
    "id": 125,
    "name": "MACEDONIA",
    "short_name": "MK",
    "code": "389",
    "currency": "MKD"
  },
  {
    "id": 126,
    "name": "MADAGASCAR",
    "short_name": "MG",
    "code": "261",
    "currency": "MGA"
  },
  {
    "id": 127,
    "name": "MALAWI",
    "short_name": "MW",
    "code": "265",
    "currency": "MWK"
  },
  {
    "id": 128,
    "name": "MALAYSIA",
    "short_name": "MY",
    "code": "60",
    "currency": "USD"
  },
  {
    "id": 129,
    "name": "MALDIVES",
    "short_name": "MV",
    "code": "960",
    "currency": "USD"
  },
  {
    "id": 130,
    "name": "MALI",
    "short_name": "ML",
    "code": "223",
    "currency": "XOF"
  },
  {
    "id": 131,
    "name": "MALTA",
    "short_name": "MT",
    "code": "356",
    "currency": "EUR"
  },
  {
    "id": 132,
    "name": "MARSHALL ISLANDS",
    "short_name": "MH",
    "code": "692",
    "currency": "USD"
  },
  {
    "id": 133,
    "name": "MAURITANIA",
    "short_name": "MR",
    "code": "222",
    "currency": "MRO"
  },
  {
    "id": 134,
    "name": "MAURITIUS",
    "short_name": "MU",
    "code": "230",
    "currency": "MUR"
  },
  {
    "id": 135,
    "name": "MAYOTTE",
    "short_name": "YT",
    "code": "262",
    "currency": "USD"
  },
  {
    "id": 136,
    "name": "MEXICO",
    "short_name": "MX",
    "code": "52",
    "currency": "MXN"
  },
  {
    "id": 137,
    "name": "MICRONESIA",
    "short_name": "FM",
    "code": "691",
    "currency": "USD"
  },
  {
    "id": 138,
    "name": "MOLDOVA",
    "short_name": "MD",
    "code": "373",
    "currency": "MDL"
  },
  {
    "id": 139,
    "name": "MONACO",
    "short_name": "MC",
    "code": "377",
    "currency": "EUR"
  },
  {
    "id": 140,
    "name": "MONGOLIA",
    "short_name": "MN",
    "code": "976",
    "currency": "USD"
  },
  {
    "id": 141,
    "name": "MONTENEGRO",
    "short_name": "ME",
    "code": "382",
    "currency": "EUR"
  },
  {
    "id": 142,
    "name": "MONTSERRAT",
    "short_name": "MS",
    "code": "1-664",
    "currency": "USD"
  },
  {
    "id": 143,
    "name": "MOROCCO",
    "short_name": "MA",
    "code": "212",
    "currency": "MAD"
  },
  {
    "id": 144,
    "name": "MOZAMBIQUE",
    "short_name": "MZ",
    "code": "258",
    "currency": "MZN"
  },
  {
    "id": 145,
    "name": "MYANMAR",
    "short_name": "MM",
    "code": "95",
    "currency": "USD"
  },
  {
    "id": 146,
    "name": "NAMIBIA",
    "short_name": "NA",
    "code": "264",
    "currency": "NAD"
  },
  {
    "id": 147,
    "name": "NAURU",
    "short_name": "NR",
    "code": "674",
    "currency": "USD"
  },
  {
    "id": 148,
    "name": "NEPAL",
    "short_name": "NP",
    "code": "977",
    "currency": "USD"
  },
  {
    "id": 149,
    "name": "NETHERLANDS",
    "short_name": "NL",
    "code": "31",
    "currency": "EUR"
  },
  {
    "id": 150,
    "name": "NETHERLANDS ANTILLES",
    "short_name": "AN",
    "code": "599",
    "currency": "USD"
  },
  {
    "id": 151,
    "name": "NEW CALEDONIA",
    "short_name": "NC",
    "code": "687",
    "currency": "USD"
  },
  {
    "id": 152,
    "name": "NEW ZEALAND",
    "short_name": "NZ",
    "code": "64",
    "currency": "USD"
  },
  {
    "id": 153,
    "name": "NICARAGUA",
    "short_name": "NI",
    "code": "505",
    "currency": "NIO"
  },
  {
    "id": 154,
    "name": "NIGER",
    "short_name": "NE",
    "code": "227",
    "currency": "NGN"
  },
  {
    "id": 155,
    "name": "NIGERIA",
    "short_name": "NG",
    "code": "234",
    "currency": "NGN"
  },
  {
    "id": 156,
    "name": "NIUE",
    "short_name": "NU",
    "code": "683",
    "currency": "USD"
  },
  {
    "id": 157,
    "name": "NORTH KOREA",
    "short_name": "KP",
    "code": "850",
    "currency": "KPW"
  },
  {
    "id": 158,
    "name": "NORTHERN MARIANA ISLANDS",
    "short_name": "MP",
    "code": "1-670",
    "currency": "USD"
  },
  {
    "id": 159,
    "name": "NORWAY",
    "short_name": "NO",
    "code": "47",
    "currency": "NOK"
  },
  {
    "id": 160,
    "name": "OMAN",
    "short_name": "OM",
    "code": "968",
    "currency": "USD"
  },
  {
    "id": 161,
    "name": "PAKISTAN",
    "short_name": "PK",
    "code": "92",
    "currency": "USD"
  },
  {
    "id": 162,
    "name": "PALAU",
    "short_name": "PW",
    "code": "680",
    "currency": "USD"
  },
  {
    "id": 163,
    "name": "PALESTINE",
    "short_name": "PS",
    "code": "970",
    "currency": "USD"
  },
  {
    "id": 164,
    "name": "PANAMA",
    "short_name": "PA",
    "code": "507",
    "currency": "PAB"
  },
  {
    "id": 165,
    "name": "PAPUA NEW GUINEA",
    "short_name": "PG",
    "code": "675",
    "currency": "USD"
  },
  {
    "id": 166,
    "name": "PARAGUAY",
    "short_name": "PY",
    "code": "595",
    "currency": "PYG"
  },
  {
    "id": 167,
    "name": "PERU",
    "short_name": "PE",
    "code": "51",
    "currency": "PEN"
  },
  {
    "id": 168,
    "name": "PHILIPPINES",
    "short_name": "PH",
    "code": "63",
    "currency": "PHP"
  },
  {
    "id": 169,
    "name": "PITCAIRN",
    "short_name": "PN",
    "code": "64",
    "currency": "USD"
  },
  {
    "id": 170,
    "name": "POLAND",
    "short_name": "PL",
    "code": "48",
    "currency": "PLN"
  },
  {
    "id": 171,
    "name": "PORTUGAL",
    "language_id": "4",
    "language": "pt",
    "short_name": "PT",
    "code": "351",
    "currency": "EUR"
  },
  {
    "id": 172,
    "name": "PUERTO RICO",
    "short_name": "PR",
    "code": "1-787",
    "currency": "USD"
  },
  {
    "id": 172,
    "name": "PUERTO RICO",
    "short_name": "PR",
    "code": "1-939",
    "currency": "USD"
  },
  {
    "id": 173,
    "name": "QATAR",
    "short_name": "QA",
    "code": "974",
    "currency": "QAR"
  },
  {
    "id": 174,
    "name": "REPUBLIC OF THE CONGO",
    "short_name": "CG",
    "code": "242",
    "currency": "CDF"
  },
  {
    "id": 175,
    "name": "REUNION",
    "short_name": "RE",
    "code": "262",
    "currency": "USD"
  },
  {
    "id": 176,
    "name": "ROMANIA",
    "short_name": "RO",
    "code": "40",
    "currency": "EUR"
  },
  {
    "id": 177,
    "name": "RUSIA",
    "short_name": "RU",
    "code": "7",
    "currency": "RUB"
  },
  {
    "id": 178,
    "name": "RWANDA",
    "short_name": "RW",
    "code": "250",
    "currency": "RWF"
  },
  {
    "id": 179,
    "name": "SAINT BARTHELEMY",
    "short_name": "BL",
    "code": "590",
    "currency": "USD"
  },
  {
    "id": 180,
    "name": "SAINT HELENA",
    "short_name": "SH",
    "code": "290",
    "currency": "USD"
  },
  {
    "id": 181,
    "name": "SAINT KITTS AND NEVIS",
    "short_name": "KN",
    "code": "1-869",
    "currency": "USD"
  },
  {
    "id": 182,
    "name": "SAINT LUCIA",
    "short_name": "LC",
    "code": "1-758",
    "currency": "USD"
  },
  {
    "id": 183,
    "name": "SAINT MARTIN",
    "short_name": "MF",
    "code": "590",
    "currency": "USD"
  },
  {
    "id": 184,
    "name": "SAINT PIERRE AND MIQUELON",
    "short_name": "PM",
    "code": "508",
    "currency": "USD"
  },
  {
    "id": 185,
    "name": "SAINT VINCENT AND THE GRENADINES",
    "short_name": "VC",
    "code": "1-784",
    "currency": "USD"
  },
  {
    "id": 186,
    "name": "SAMOA",
    "short_name": "WS",
    "code": "685",
    "currency": "USD"
  },
  {
    "id": 187,
    "name": "SAN MARINO",
    "short_name": "SM",
    "code": "378",
    "currency": "EUR"
  },
  {
    "id": 188,
    "name": "SAO TOME AND PRINCIPE",
    "short_name": "ST",
    "code": "239",
    "currency": "STD"
  },
  {
    "id": 189,
    "name": "SAUDI ARABIA",
    "short_name": "SA",
    "code": "966",
    "currency": "SAR"
  },
  {
    "id": 190,
    "name": "SENEGAL",
    "short_name": "SN",
    "code": "221",
    "currency": "XOF"
  },
  {
    "id": 191,
    "name": "SERBIA",
    "short_name": "RS",
    "code": "381",
    "currency": "EUR"
  },
  {
    "id": 192,
    "name": "SEYCHELLES",
    "short_name": "SC",
    "code": "248",
    "currency": "SCR"
  },
  {
    "id": 193,
    "name": "SIERRA LEONE",
    "short_name": "SL",
    "code": "232",
    "currency": "SLL"
  },
  {
    "id": 194,
    "name": "SINGAPORE",
    "short_name": "SG",
    "code": "65",
    "currency": "USD"
  },
  {
    "id": 195,
    "name": "SINT MAARTEN",
    "short_name": "SX",
    "code": "1-721",
    "currency": "USD"
  },
  {
    "id": 196,
    "name": "SLOVAKIA",
    "short_name": "SK",
    "code": "421",
    "currency": "EUR"
  },
  {
    "id": 197,
    "name": "SLOVENIA",
    "short_name": "SI",
    "code": "386",
    "currency": "EUR"
  },
  {
    "id": 198,
    "name": "SOLOMON ISLANDS",
    "short_name": "SB",
    "code": "677",
    "currency": "USD"
  },
  {
    "id": 199,
    "name": "SOMALIA",
    "short_name": "SO",
    "code": "252",
    "currency": "SOS"
  },
  {
    "id": 200,
    "name": "SOUTH AFRICA",
    "short_name": "ZA",
    "code": "27",
    "currency": "ZAR"
  },
  {
    "id": 201,
    "name": "SOUTH KOREA",
    "short_name": "KR",
    "code": "82",
    "currency": "KRW"
  },
  {
    "id": 202,
    "name": "SOUTH SUDAN",
    "short_name": "SS",
    "code": "211",
    "currency": "USD"
  },
  {
    "id": 203,
    "name": "ESPAÑA",
    "short_name": "ES",
    "code": "34",
    "currency": "EUR"
  },
  {
    "id": 204,
    "name": "SRI LANKA",
    "short_name": "LK",
    "code": "94",
    "currency": "USD"
  },
  {
    "id": 205,
    "name": "SUDAN",
    "short_name": "SD",
    "code": "249",
    "currency": "SDG"
  },
  {
    "id": 206,
    "name": "SURINAME",
    "short_name": "SR",
    "code": "597",
    "currency": "SRD"
  },
  {
    "id": 207,
    "name": "SVALBARD AND JAN MAYEN",
    "short_name": "SJ",
    "code": "47",
    "currency": "USD"
  },
  {
    "id": 208,
    "name": "SWAZILAND",
    "short_name": "SZ",
    "code": "268",
    "currency": "SZL"
  },
  {
    "id": 209,
    "name": "SWEDEN",
    "short_name": "SE",
    "code": "46",
    "currency": "USD"
  },
  {
    "id": 210,
    "name": "SWITZERLAND",
    "short_name": "CH",
    "code": "41",
    "currency": "USD"
  },
  {
    "id": 211,
    "name": "SYRIA",
    "short_name": "SY",
    "code": "963",
    "currency": "USD"
  },
  {
    "id": 212,
    "name": "TAIWAN",
    "short_name": "TW",
    "code": "886",
    "currency": "USD"
  },
  {
    "id": 213,
    "name": "TAJIKISTAN",
    "short_name": "TJ",
    "code": "992",
    "currency": "USD"
  },
  {
    "id": 214,
    "name": "TANZANIA",
    "short_name": "TZ",
    "code": "255",
    "currency": "TZS"
  },
  {
    "id": 215,
    "name": "THAILAND",
    "short_name": "TH",
    "code": "66",
    "currency": "USD"
  },
  {
    "id": 216,
    "name": "TOGO",
    "short_name": "TG",
    "code": "228",
    "currency": "XOF"
  },
  {
    "id": 217,
    "name": "TOKELAU",
    "short_name": "TK",
    "code": "690",
    "currency": "USD"
  },
  {
    "id": 218,
    "name": "TONGA",
    "short_name": "TO",
    "code": "676",
    "currency": "USD"
  },
  {
    "id": 219,
    "name": "TRINIDAD AND TOBAGO",
    "short_name": "TT",
    "code": "1-868",
    "currency": "USD"
  },
  {
    "id": 220,
    "name": "TUNISIA",
    "short_name": "TN",
    "code": "216",
    "currency": "TND"
  },
  {
    "id": 221,
    "name": "TURKEY",
    "short_name": "TR",
    "code": "90",
    "currency": "USD"
  },
  {
    "id": 222,
    "name": "TURKMENISTAN",
    "short_name": "TM",
    "code": "993",
    "currency": "USD"
  },
  {
    "id": 223,
    "name": "TURKS AND CAICOS ISLANDS",
    "short_name": "TC",
    "code": "1-649",
    "currency": "USD"
  },
  {
    "id": 224,
    "name": "TUVALU",
    "short_name": "TV",
    "code": "688",
    "currency": "USD"
  },
  {
    "id": 225,
    "name": "U.S. VIRGIN ISLANDS",
    "short_name": "VI",
    "code": "1-340",
    "currency": "USD"
  },
  {
    "id": 226,
    "name": "UGANDA",
    "short_name": "UG",
    "code": "256",
    "currency": "UGX"
  },
  {
    "id": 227,
    "name": "UKRAINE",
    "short_name": "UA",
    "code": "380",
    "currency": "USD"
  },
  {
    "id": 228,
    "name": "UNITED ARAB EMIRATES",
    "short_name": "AE",
    "code": "971",
    "currency": "AED"
  },
  {
    "id": 229,
    "name": "REINO UNIDO",
    "short_name": "GB",
    "code": "44",
    "currency": "EUR"
  },
  {
    "id": 230,
    "name": "ESTADOS UNIDOS",
    "short_name": "US",
    "code": "1",
    "currency": "USD"
  },
  {
    "id": 231,
    "name": "URUGUAY",
    "short_name": "UY",
    "code": "598",
    "currency": "UYU"
  },
  {
    "id": 232,
    "name": "UZBEKISTAN",
    "short_name": "UZ",
    "code": "998",
    "currency": "USD"
  },
  {
    "id": 233,
    "name": "VANUATU",
    "short_name": "VU",
    "code": "678",
    "currency": "USD"
  },
  {
    "id": 234,
    "name": "VATICAN",
    "short_name": "VA",
    "code": "379",
    "currency": "USD"
  },
  {
    "id": 235,
    "name": "VENEZUELA",
    "short_name": "VE",
    "code": "58",
    "currency": "VES"
  },
  {
    "id": 236,
    "name": "VIETNAM",
    "short_name": "VN",
    "code": "84",
    "currency": "USD"
  },
  {
    "id": 237,
    "name": "WALLIS AND FUTUNA",
    "short_name": "WF",
    "code": "681",
    "currency": "USD"
  },
  {
    "id": 238,
    "name": "WESTERN SAHARA",
    "short_name": "EH",
    "code": "212",
    "currency": "USD"
  },
  {
    "id": 239,
    "name": "YEMEN",
    "short_name": "YE",
    "code": "967",
    "currency": "USD"
  },
  {
    "id": 240,
    "name": "ZAMBIA",
    "short_name": "ZM",
    "code": "260",
    "currency": "ZMW"
  },
  {
    "id": 241,
    "name": "ZIMBABWE",
    "short_name": "ZW",
    "code": "263",
    "currency": "ZWD"
  }
]
